import React from 'react';
import { narrowHeaderFooterMargins, normalHeaderFooterMargins } from '../margins';
import { EFontFamily, EMarginSize, getFontFamilyCss } from '../types';

export type IExportPdfFilter = {
  marginSize: EMarginSize;
  filters: React.ReactElement[];
  filterLabel: string;
  displayFilter: boolean;
  displayHeader: boolean;
  fontFamily: EFontFamily;
};

export const ExportPdfFilter: React.FC<IExportPdfFilter> = (props) => {
  const { filters, filterLabel, displayFilter, displayHeader, fontFamily } = props;

  return (
    <>
      {displayFilter && displayHeader && (
        <div
          data-test="pdf-filter-container"
          className="filter-container"
          style={{
            fontSize: '8pt',
            fontFamily: getFontFamilyCss(fontFamily),
            fontWeight: 400,
            lineHeight: '12pt',
            width: '100%',
            ...(props.marginSize === EMarginSize.narrow
              ? {
                  marginLeft: narrowHeaderFooterMargins['margin-left'],
                  marginRight: narrowHeaderFooterMargins['margin-right']
                }
              : {
                  marginLeft: normalHeaderFooterMargins['margin-left'],
                  marginRight: normalHeaderFooterMargins['margin-right']
                }),
            left: 0,
            right: 0,
            marginTop: '16px',
            marginBottom: '16px',
            textAlign: 'left'
          }}
        >
          {filterLabel}: {filters}
        </div>
      )}
    </>
  );
};
